import React from 'react';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer>
            <p>&copy; {currentYear} Mi portafolio NOECER. Todos los derechos reservados.</p>
        </footer>
    );
};

export default Footer;